import { Component, ComponentFactoryResolver, Input, OnInit, ViewChild } from '@angular/core';
import { ExpandedComponentDirective } from '../../../directives/expanded-component.directive';

@Component({
  selector: 'app-expanded-row',
  templateUrl: './expanded-row.component.html',
  styleUrls: ['./expanded-row.component.scss'],
  standalone: true,
  imports: [
    ExpandedComponentDirective,
  ],
})
export class ExpandedRowComponent implements OnInit {

  @Input() element: any;
  @Input() expandedComponent: any;
  @ViewChild(ExpandedComponentDirective, { static: true }) dynamicComponent!: ExpandedComponentDirective;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {
  }

  ngOnInit() {
    this.loadComponent();
  }

  loadComponent() {
    if (this.expandedComponent) {
      const { viewContainerRef } = this.dynamicComponent;
      viewContainerRef.clear();
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.expandedComponent);
      const componentRef = viewContainerRef.createComponent(componentFactory);
      (componentRef.instance as any).value = this.element;
    } else {
      console.error('Component not provided');
    }
  }

}
